import React from 'react'
import { FontIcon, Button, Tooltipped, SimplePosition } from 'react-md'
import { usePromiseTracker } from 'react-promise-tracker'

import { useAuth } from 'contexts/auth/auth-context'
import { Theme } from 'contexts/auth/types'

interface Props {
  id: string
  tooltip?: string
  tooltipPosition?: SimplePosition
  action: () => void
  disabled?: boolean
}

const DeleteButton: React.FC<Props> = ({ id, tooltip, tooltipPosition, action, disabled }) => {
  const { promiseInProgress } = usePromiseTracker()
  const { theme } = useAuth()

  return (
    <Tooltipped id={id} tooltip={tooltip || 'Excluir'} position={tooltipPosition || 'above'}>
      <Button
        theme={disabled || promiseInProgress ? 'disabled' : 'clear'}
        disabled={disabled || promiseInProgress}
        buttonType='icon'
        style={
          disabled || promiseInProgress
            ? { margin: 2 }
            : theme === Theme.Dark
            ? { backgroundColor: '#d32f2f', color: '#FFFFFF', margin: 2 }
            : { backgroundColor: '#e57373', color: '#212121', margin: 2 }
        }
        onClick={action}>
        <FontIcon>close</FontIcon>
      </Button>
    </Tooltipped>
  )
}

export default DeleteButton
